module.exports = __webpack_public_path__ + "static/media/DSC04395.97b350c5.JPG";